import { useQuery } from '@tanstack/react-query'

import { ProductService } from '@/api/services/ProductService'
import { IProductConfiguration } from '@/types'

export const PRODUCT_CONFIGURATIONS_QUERY_KEY = ['product-configurations']

// The list is global and changes rarely, so one query serves the whole page and
// its expanded rows; eligibility rules arrive on the same payload and need no
// call of their own.
export const useProductConfigurations = () =>
  useQuery<IProductConfiguration[]>({
    queryKey: PRODUCT_CONFIGURATIONS_QUERY_KEY,
    queryFn: () => ProductService.fetchProductConfigurations(),
  })
